// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    AutocompleteContentStyles,
    autocompleteContentStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteContent";
import { autoCompleteSharedStyles } from "@sc/App/WidgetExtensions/Header/SearchInputExtensions";
import { mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const autoCompleteContentExtensions: AutocompleteContentStyles = {
    headerText: {
        ...autoCompleteSharedStyles?.headerText,
    },
    link: {
        ...mergeWithCss(autoCompleteSharedStyles?.link, {
            css: css`
                display: flex;
                flex-wrap: wrap;
                gap: 4px;
                margin-bottom: 13px;
            `,
        }),
    },
    focusedLink: {
        ...mergeWithCss(autoCompleteSharedStyles.focusedLink, {
            typographyProps: {
                weight: "bold",
            },
        }),
    },
};

autocompleteContentStyles.headerText = autoCompleteContentExtensions.headerText;
autocompleteContentStyles.link = autoCompleteContentExtensions.link;
autocompleteContentStyles.focusedLink = autoCompleteContentExtensions.focusedLink;
